import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-provence-stone text-white/80">
      <div className="container py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">

          <div className="space-y-4">
            <div>
              <h3 className="text-2xl font-serif font-bold italic text-white tracking-wider">Mas Capon</h3>
              <p className="text-[11px] font-sans tracking-[0.2em] text-provence-gold uppercase mt-1">
                Saint-Rémy-de-Provence
              </p>
            </div>
            <p className="text-sm leading-relaxed text-white/60 max-w-xs">
              Ein authentisches provenzalisches Landhaus — zum Wohnen, Erleben und Entschleunigen.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xs font-sans font-semibold tracking-[0.2em] uppercase text-provence-gold">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm">
                <MapPin className="h-4 w-4 text-provence-lavender flex-shrink-0" />
                <span>Saint-Rémy-de-Provence, Frankreich</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Phone className="h-4 w-4 text-provence-lavender flex-shrink-0" />
                <a href="tel:+491777700460" className="hover:text-white transition-colors">+49 177 7700 460</a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="h-4 w-4 text-provence-lavender flex-shrink-0" />
                <a href="mailto:bookingmascapon@gmail.com" className="hover:text-white transition-colors">
                  bookingmascapon@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xs font-sans font-semibold tracking-[0.2em] uppercase text-provence-gold">
              Rechtliches
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm hover:text-white transition-colors">
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm hover:text-white transition-colors">
                  AGB & Impressum
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Mas Capon. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-provence-lavender"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-provence-terracotta"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-provence-gold"></span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
